import React, { useState } from "react";
import { Link } from "react-router-dom";
import image from "../../assets/images/how-it-works.avif";

function HowItWorks({ data }) {
  const [activeService, setActiveService] = useState(0);
  
  return (
    <section className="section cta-section">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h2 className="section-title">How It Works</h2>
            <p className="section-subtitle">
              Our proven process ensures successful implementation and delivery of your cloud solutions
            </p>
          </div>
        </div>

        <div className="how-it-works-container">
          {/* Desktop Tabs */}
          <div className="how-it-works-tabs">
            <div className="tabs-container">
              {data?.map((item, index) => (
                <button
                  key={index}
                  className={`tab-button ${activeService === index ? 'active' : ''}`}
                  onClick={() => setActiveService(index)}
                >
                  {item.title}
                </button>
              ))}
            </div>
          </div>
          
          {/* Content Area */}
          <div className="how-it-works-content">
            <p className="how-it-works-description">
              {data[activeService]?.description}
            </p>
          </div>
          
          {/* Mobile Cards */}
          <div className="how-it-works-mobile-cards">
            {data?.map((item, index) => (
              <div className="mobile-card" key={index}>
                <div className="service-card">
                  <div className="service-content">
                    <h4 className="service-title">
                      {item.title}
                    </h4>
                    <p className="service-description">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Mobile Image */}
          <div className="how-it-works-mobile-image">
            <img src={image} alt="" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
